// extracted by mini-css-extract-plugin
module.exports = {"layout":"ResponsiveLayout_layout__UpXUH","centered":"ResponsiveLayout_centered__8kt6l"};